import axios from "axios";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { QrReader } from "react-qr-reader";
import CONFIG from "../constanta/config";
import logoDoku from "../assets/logo-doku.png";

const PopupAdd = (props) => {
  const [dataPayload, setDataPayload] = useState(null);
  const [popupConfirm, setPopupConfirm] = useState(false);
  const [popupSuccessManualPayment, setPopupSuccessManualPayment] =
    useState(false);
  const [isEarly, setIsEarly] = useState(true);
  const [listProfesi, setListProfesi] = useState([]);
  const [listPaket, setListPaket] = useState([]);
  const [seat, setSeat] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [msgVc, setMsgVc] = useState("");
  const [kuota, setKuota] = useState(0);
  const [voucherValid, setVoucherValid] = useState(null);
  const maxKuota = 20;
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const profesi = [
    {
      nama: "Sub Specialist",
      paket: [
        {
          nama: "Symposium",
          value: "SYMPOSIUM",
          harga_early: 1200000,
          harga_normal: 1500000,
          label_early: "Symposium",
          label_normal: "Symposium",
        },
        {
          nama: "Workshop",
          value: "WORKSHOP",
          harga_early: 1600000,
          harga_normal: 2000000,
          label_early: "Workshop",
          label_normal: "Workshop",
        },
        {
          nama: "Symposium & Workshop",
          value: "SYMPOSIUM, WORKSHOP",
          harga_early: 2600000,
          harga_normal: 3200000,
          label_early: "Symposium & Workshop",
          label_normal: "Symposium & Workshop",
        },
      ],
    },

    {
      nama: "Specialist",
      paket: [
        {
          nama: "Symposium",
          value: "SYMPOSIUM",
          harga_early: 1200000,
          harga_normal: 1500000,
          label_early: "Symposium",
          label_normal: "Symposium",
        },
        {
          nama: "Workshop",
          value: "WORKSHOP",
          harga_early: 1600000,
          harga_normal: 2000000,
          label_early: "Workshop",
          label_normal: "Workshop",
        },
        {
          nama: "Symposium & Workshop",
          value: "SYMPOSIUM, WORKSHOP",
          harga_early: 2600000,
          harga_normal: 3200000,
          label_early: "Symposium & Workshop",
          label_normal: "Symposium & Workshop",
        },
      ],
    },

    {
      nama: "General Practitioner",
      paket: [
        {
          nama: "Symposium",
          value: "SYMPOSIUM",
          harga_early: 400000,
          harga_normal: 500000,
          label_early: "Symposium",
          label_normal: "Symposium",
        },
      ],
    },

    {
      nama: "Nurse",
      paket: [
        {
          nama: "Symposium",
          value: "SYMPOSIUM",
          harga_early: 240000,
          harga_normal: 300000,
          label_early: "Symposium",
          label_normal: "Symposium",
        },
      ],
    },

    {
      nama: "Pharmacist",
      paket: [
        {
          nama: "Symposium",
          value: "SYMPOSIUM",
          harga_early: 240000,
          harga_normal: 300000,
          label_early: "Symposium",
          label_normal: "Symposium",
        },
      ],
    },

    {
      nama: "Other",
      paket: [
        {
          nama: "Symposium",
          value: "SYMPOSIUM",
          harga_early: 240000,
          harga_normal: 300000,
          label_early: "Symposium",
          label_normal: "Symposium",
        },
      ],
    },
  ];

  const formatRupiah = (angka) => {
    angka = Math.round(angka).toString();
    let prefix = "Rp. ";
    var number_string = angka.replace(/[^,\d]/g, "").toString(),
      split = number_string.split(","),
      sisa = split[0].length % 3,
      rupiah = split[0].substr(0, sisa),
      ribuan = split[0].substr(sisa).match(/\d{3}/gi);

    if (ribuan) {
      let separator = sisa ? "." : "";
      rupiah += separator + ribuan.join(".");
    }

    rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
    return prefix == undefined ? rupiah : rupiah ? "Rp. " + rupiah : "";
  };

  useEffect(() => {
    getKuotaWorkshop();
  }, []);

  useEffect(() => {
    setListProfesi(profesi);
  }, [kuota]);

  useEffect(() => {
    if (listProfesi.length > 0) {
      setValue("profession", listProfesi[0].nama);
    }
  }, [listProfesi]);

  useEffect(() => {
    handleRemoveCode();

    let _profesi = profesi.find((item) => item.nama === watch("profession"));
    if (_profesi !== undefined) {
      let arr = [];

      if (kuota >= maxKuota) {
        arr = _profesi.paket.filter(
          (item) => !item.nama.toLowerCase().includes("workshop")
        );
      } else {
        arr = _profesi.paket;
      }

      setListPaket(arr);
    }
  }, [watch("profession"), kuota]);

  useEffect(() => {
    if (listPaket.length > 0) {
      setValue("partisipation", JSON.stringify(listPaket[0]));
    }
  }, [listPaket]);

  const isValidEmail = (email) =>
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    );

  const handleEmailValidation = (email) => {
    console.log("ValidateEmail was called with", email);

    const isValid = isValidEmail(email);

    const validityChanged =
      (errors.email && isValid) || (!errors.email && !isValid);

    if (validityChanged) {
      console.log("Fire tracker with", isValid ? "Valid" : "Invalid");
    }

    return isValid;
  };

  const onSubmit = (data) => {
    setDataPayload(data);
    console.log(data);
    setMsg("");
    setPopupConfirm(true);
  };

  const getKuotaWorkshop = () => {
    axios
      .get(CONFIG.URL + "/user/workshop")
      .then(function (response) {
        if (response?.data?.status === "SUCCESS") {
          setKuota(response?.data?.workshop);
        } else {
        }
      })
      .catch(function (error) {});
  };

  const onPaymentDoku = () => {
    const data = dataPayload;
    setMsg("");
    setLoading(true);

    let _partisipation = JSON.parse(data.partisipation);

    const payload = {
      name: data.fullname,
      email: data.email,
      phone: data.phone,
      institution: data.institution,
      city: data.city,
      profession: data.profession,
      partisipation: _partisipation.value,
      admission_fee:
        voucherValid !== null
          ? voucherValid?.price
          : isEarly
          ? _partisipation.harga_early
          : _partisipation.harga_normal,
      payment_type: "doku",
      voucher: voucherValid !== null ? voucherValid?.voucher : "",
    };

    var form_data = new FormData();

    for (var key in payload) {
      form_data.append(key, payload[key]);
    }

    axios
      .post(CONFIG.URL + "/user/register", form_data)
      .then(function (response) {
        setLoading(false);
        if (response?.data?.status === "SUCCESS") {
          window.loadJokulCheckout(response.data.doku.response.payment.url);
        } else {
          setMsg(
            "Something went wrong, please try again or contact admin, [Error Code: " +
              response?.data?.error?.code +
              "]"
          );
        }
      })
      .catch(function (error) {
        setLoading(false);
        setMsg("Something went wrong, please try again or contact admin");
      });
  };

  const onPaymentManual = () => {
    const data = dataPayload;
    setMsg("");
    setLoading(true);

    let _partisipation = JSON.parse(data.partisipation);

    const payload = {
      name: data.fullname,
      email: data.email,
      phone: data.phone,
      institution: data.institution,
      city: data.city,
      profession: data.profession,
      partisipation: _partisipation.value,
      admission_fee:
        voucherValid !== null
          ? voucherValid?.price
          : isEarly
          ? _partisipation.harga_early
          : _partisipation.harga_normal,
      payment_type: "manual",
      voucher: voucherValid !== null ? voucherValid?.voucher : "",
    };

    var form_data = new FormData();

    for (var key in payload) {
      form_data.append(key, payload[key]);
    }

    axios
      .post(CONFIG.URL + "/user/register", form_data)
      .then(function (response) {
        setLoading(false);
        if (response?.data?.status === "SUCCESS") {
          setPopupSuccessManualPayment(true);
          setPopupConfirm(false);
        } else {
          setMsg(
            "Something went wrong, please try again or contact admin, [Error Code: " +
              response?.data?.error_code +
              "]"
          );
        }
      })
      .catch(function (error) {
        setLoading(false);
        setMsg("Something went wrong, please try again or contact admin");
      });
  };

  const generateJenisPaket = () => {
    let _partisipation = JSON.parse(dataPayload.partisipation);

    return (
      <>
        <div className="text-lg font-bold">
          {_partisipation.nama} ={" "}
          {isEarly
            ? formatRupiah(_partisipation.harga_early)
            : formatRupiah(_partisipation.harga_normal)}
        </div>
      </>
    );
  };

  const handleCheckCode = () => {
    setMsgVc("");
    setLoading(true);
    const payload = {
      profession: checkNameProfession(watch("profession")),
      voucher: watch("voucher_code"),
    };

    var form_data = new FormData();

    for (var key in payload) {
      form_data.append(key, payload[key]);
    }

    axios
      .post(CONFIG.URL + "/user/voucher", form_data)
      .then(function (response) {
        setLoading(false);
        if (response?.data?.status === "SUCCESS") {
          setVoucherValid(response.data);
        } else {
          setMsgVc(response?.data?.message);
        }
      })
      .catch(function (error) {
        setLoading(false);
        setMsgVc("Something went wrong, please try again or contact admin");
      });
  };

  const handleRemoveCode = () => {
    setVoucherValid(null);
    setMsgVc("");
    setValue("voucher_code", "");
  };

  const checkNameProfession = (val) => {
    if (val === "Sub Specialist") {
      return "Subspecialist";
    } else {
      return val;
    }
  };

  return (
    <>
      {loading && (
        <>
          <div className="flex flex-col justify-center items-center fixed z-[999999] top-0 left-0 w-screen h-screen bg-[#000000d6] text-white justify-start items-start font-semibold text-xl">
            Loading...
          </div>
        </>
      )}

      {popupConfirm && (
        <div className="fixed bg-[#000000d1] w-screen h-screen z-[99999] flex justify-center items-center p-5">
          <div className="w-full h-auto bg-[#0d132a] border-2 border-white text-white rounded-lg p-4 flex flex-col justify-center items-center">
            {msg !== "" && (
              <div className="bg-red-500 text-white  px-5 rounded-md mb-8">
                <div className="text-white text-center my-3 font-bold">
                  {msg}.
                </div>
              </div>
            )}

            <div className="text-lg font-bold pb-2 border-b border-white mb-5 ">
              Please Check Your Order
            </div>
            <div className="text-lg font-bold mb-2">
              Profesi: {dataPayload.profession}
            </div>
            <div className="text-lg font-bold">Jenis Paket:</div>
            <div>{generateJenisPaket()}</div>

            {voucherValid !== null && (
              <div className="bg-green-700 text-white  px-2 py-2 rounded-md flex flex-col justify-between items-center mt-4 w-full">
                <div className="text-white text-lg text-center my-1 font-bold uppercase">
                  Voucher: {voucherValid.voucher}
                </div>
                <div className="text-white text-lg text-center my-1 font-bold">
                  Total Bayar: {formatRupiah(voucherValid.price)}
                </div>
              </div>
            )}

            <div className="w-full flex flex-col justify-center items-center mb-5 mt-10">
              {voucherValid !== null && voucherValid?.price === "0" ? (
                <div>
                  <button
                    onClick={() => onPaymentManual()}
                    className="mt-4 flex justify-between items-center min-w-[260px] px-2 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-white font-bold"
                  >
                    <span className="w-full text-center uppercase">
                      GRAB YOUR TICKET
                    </span>
                  </button>

                  <div className="my-8 border-b border-white h-[1px] w-full"></div>
                </div>
              ) : (
                <div>
                  <button
                    onClick={() => onPaymentDoku()}
                    className="flex justify-between items-center min-w-[260px] px-2 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-white font-bold"
                  >
                    <img
                      className="w-10 object-contain"
                      src={logoDoku}
                      alt=""
                    />

                    <span className="w-full text-center">
                      PAYMENT WITH DOKU
                    </span>
                  </button>

                  <button
                    onClick={() => onPaymentManual()}
                    className="mt-4 flex justify-between items-center min-w-[260px] px-2 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-white font-bold"
                  >
                    <span className="w-full text-center uppercase">
                      MANUAL PAYMENT
                    </span>
                  </button>

                  <div className="my-8 border-b border-white h-[1px] w-full"></div>
                </div>
              )}

              <button
                onClick={() => setPopupConfirm(false)}
                className="min-w-[140px] px-10 py-2 bg-transprent border-2 border-red-500 rounded-lg text-white font-bold"
              >
                BACK
              </button>
            </div>
          </div>
        </div>
      )}

      {popupSuccessManualPayment && (
        <div className="fixed bg-[#000000d1] w-screen h-screen z-[99999] flex justify-center items-center p-5">
          <div className="w-full h-auto bg-[#0d132a] border-2 border-white text-white rounded-lg p-4 flex flex-col justify-center items-center">
            {msg !== "" && (
              <div className="bg-red-500 text-white  px-5 rounded-md mb-8">
                <div className="text-white text-center my-3 font-bold">
                  {msg}.
                </div>
              </div>
            )}

            <div className="text-2xl font-bold pb-2 mb-5 text-center">
              Terima kasih telah melakukan pendaftaran
            </div>

            <div className="text-2xl font-bold pb-2 mb-5 text-center">
              Untuk melakukan pembayaran silahkan cek email : {dataPayload.email}
            </div>


            <div className="w-full flex flex-col justify-center items-center mb-5 mt-2">
              <button
                onClick={() => props.onClose()}
                className="min-w-[140px] px-10 py-2 bg-transprent border-2 border-red-500 rounded-lg text-white font-bold"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
        <div className="absolute z-20 top-0 left-0 w-screen h-screen bg-[#0d132a]"></div>
        <div className="absolute py-5 z-50  top-16 left-0 w-screen h-auto flex flex-col justify-start items-center">
          <div className="flex flex-col space-y-2">
            <div className=" text-white text-center font-bold text-2xl uppercase">
              REGISTRATION
            </div>
            {/* <div className=" text-white text-center font-semibold">
              Silahkan isi data
            </div> */}
          </div>
          <div className="h-auto flex flex-col w-full px-10  max-w-lg mt-10">
            <div className="mb-1">
              <div className="text-[#fbda08] mb-1">Full Name :</div>
              <input
                {...register("fullname", { required: true })}
                className="w-full mb-1 min-w-[160px] px-2 py-2 bg-[#030609] border-2 border-white rounded-lg text-white"
              />
              {errors.fullname && (
                <span className="text-red-500 text-sm">
                  This field is required
                </span>
              )}
            </div>

            <div className="mb-1">
              <div className="text-[#fbda08] mb-1">Email :</div>
              <input
                {...register("email", {
                  required: true,
                  validate: isValidEmail,
                })}
                className="w-full mb-1 min-w-[160px] px-2 py-2 bg-[#030609] border-2 border-white rounded-lg text-white"
              />
              {errors.email && (
                <span className="text-red-500 text-sm">
                  This field is required / invalid email format
                </span>
              )}
            </div>

            <div className="mb-1">
              <div className="text-[#fbda08] mb-1">Whatsapp Number :</div>
              <input
                {...register("phone", { required: true })}
                type="number"
                className="w-full mb-1 min-w-[160px] px-2 py-2 bg-[#030609] border-2 border-white rounded-lg text-white"
              />
              {errors.phone && (
                <span className="text-red-500 text-sm">
                  This field is required
                </span>
              )}
            </div>

            <div className="mb-1">
              <div className="text-[#fbda08] mb-1">Institution :</div>
              <input
                {...register("institution", { required: true })}
                className="w-full mb-1 min-w-[160px] px-2 py-2 bg-[#030609] border-2 border-white rounded-lg text-white"
              />
              {errors.institution && (
                <span className="text-red-500 text-sm">
                  This field is required
                </span>
              )}
            </div>

            <div className="mb-1">
              <div className="text-[#fbda08] mb-1">City :</div>
              <input
                {...register("city", { required: true })}
                className="w-full mb-1 min-w-[160px] px-2 py-2 bg-[#030609] border-2 border-white rounded-lg text-white"
              />
              {errors.city && (
                <span className="text-red-500 text-sm">
                  This field is required
                </span>
              )}
            </div>

            <div className="mb-1">
              <div className="text-[#fbda08] mb-1">Profession :</div>

              <select
                {...register("profession", { required: true })}
                className="w-full mb-1 min-w-[160px] px-2 py-2 bg-[#030609] border-2 border-white rounded-lg text-white"
              >
                {listProfesi.map((item, key) => {
                  return (
                    <option key={key} value={item.nama}>
                      {item.nama}
                    </option>
                  );
                })}
              </select>
              {errors.profession && (
                <span className="text-red-500 text-sm">
                  This field is required
                </span>
              )}
            </div>

            <div className="mb-1">
              <div className="text-[#fbda08] mb-1">Package :</div>

              <select
                {...register("partisipation", { required: true })}
                className="w-full mb-1 min-w-[160px] px-2 py-2 bg-[#030609] border-2 border-white rounded-lg text-white"
              >
                {listPaket.map((item, key) => {
                  return (
                    <option key={key} value={JSON.stringify(item)}>
                      {isEarly ? item.label_early : item.label_normal}
                    </option>
                  );
                })}
              </select>
              {errors.partisipation && (
                <span className="text-red-500 text-sm">
                  This field is required
                </span>
              )}
            </div>

            <hr className="mt-4 mb-1" />

            <div className="mb-1 border px-4 py-2 mt-4 bg-[#fbda08] rounded-md w-full flex flex-col">
              <div className="flex items-end justify-end w-full">
                <div className="w-full">
                  <div className="text-black font-bold mb-1">Voucher Code</div>
                  <input
                    disabled={voucherValid !== null}
                    {...register("voucher_code", { required: false })}
                    className={`${
                      voucherValid !== null ? "bg-gray-600" : "bg-[#030609]"
                    } uppercase w-full mb-1 min-w-[160px] px-2 py-2  border-2 border-white rounded-lg text-white`}
                  />
                </div>

                <button
                  type="button"
                  onClick={() =>
                    voucherValid !== null
                      ? handleRemoveCode()
                      : handleCheckCode()
                  }
                  className="mb-1 ml-1 h-[44px] w-max px-3 py-2 bg-[#0d132a] border-2 border-white rounded-lg text-white font-bold text-sm"
                >
                  {voucherValid === null ? "APPLY" : "REMOVE"}
                </button>
              </div>

              {msgVc !== "" && (
                <div className="bg-red-500 text-white  px-5 rounded-md">
                  <div className="text-white text-sm text-center my-1 font-bold">
                    {msgVc}.
                  </div>
                </div>
              )}

              {voucherValid !== null && (
                <div className="bg-green-700 text-white  px-2 py-2 rounded-md flex flex-col justify-between items-start">
                  <div className="text-white text-sm text-center my-1 font-bold uppercase">
                    Voucher: {voucherValid.voucher}
                  </div>
                  <div className="text-white text-sm text-center my-1 font-bold">
                    Total Bayar: {formatRupiah(voucherValid.price)}
                  </div>
                </div>
              )}
            </div>

            <hr className="mt-4 mb-1" />
          </div>

          <div className="w-full flex justify-center items-center space-x-5 my-5">
            <button
              type="button"
              onClick={() => props.onClose()}
              className="min-w-[140px] px-10 py-2 bg-transprent border-2 border-red-500 rounded-lg text-white font-bold"
            >
              CANCEL
            </button>

            <button
              type="sumbit"
              className="min-w-[160px] px-10 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-white font-bold"
            >
              SUBMIT
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default PopupAdd;
